import { REFRESHING_TOKEN,
    REFRESHING_TOKEN_ERROR,
     DONE_REFRESHING_TOKEN, 
     AUTHENTICATION_ADDUPDATE_TOKEN } from '../actions/refreshToken';
import { LOGINSTATE_LOGOUT } from '../actions/login';

export function auth (state = {token:'', customer: '',isFetchingToken: false},action) {
    switch(action.type) {       

        case AUTHENTICATION_ADDUPDATE_TOKEN : {               
            let newState = { ...state, token: action.data.token, customer: action.data.cust, refreshToken: action.data.refreshToken};
            return newState;
        } 

        case LOGINSTATE_LOGOUT : {
            return { token: '', refreshToken: '', customer: '', freshTokenPromise: undefined };
        }

        case REFRESHING_TOKEN: {
            let newState = {...state, freshTokenPromise: action.freshTokenPromise };
            return newState;
        }

        case REFRESHING_TOKEN_ERROR: {
            let newState = {};
            return newState;
        }
        case DONE_REFRESHING_TOKEN: {
            let newState = {...state, freshTokenPromise: undefined}
            return newState; 
        }        

        default:
        return state;     
       
    }
}
export function externalAuthentication(state = {isAuthenticated: false}, action) {
    switch (action.type) {
        case 'AUTHENTICATION_SUCCESS':
        {
            return {...action.data, isAuthenticated: true};
        }
        default:
            return state;
    }
}